module.exports = "/_next/static/images/11588fe7db70a233dc59c3b3435515b4-man-holding-device-2@3x.jpg";